import { Component, Input, OnInit } from '@angular/core';
import { StoryViewerComponent } from '../story-viewer/story-viewer.component';
import { ModalController } from '@ionic/angular';
import { AssetlinksService } from 'src/app/services/assetlinks.service';
import { OutletPage } from 'src/app/pages/outlet/outlet.page';
import { DateTimeService } from 'src/app/services/date-time.service';
import { OutletDealzService } from 'src/app/services/outlet-dealz.service';
import { Outlet, Shop } from 'src/app/models/interfaces';
import { ShopPage } from 'src/app/pages/shop/shop.page';

@Component({
  selector: 'app-shop-avatar',
  templateUrl: './shop-avatar.component.html',
  styleUrls: ['./shop-avatar.component.scss'],
})
export class ShopAvatarComponent  implements OnInit {
  @Input() shop:Shop
  @Input() shopOutlets:Outlet[]
  constructor(
    private modalCtrl:ModalController,
    public assetLinksService:AssetlinksService,
    private dateTimeService:DateTimeService,
  ) { }

  ngOnInit() {}

  async viewAction(){
    try {
      const modal = await this.modalCtrl.create({
        component: ShopPage,
        mode: 'ios',
        initialBreakpoint: 1,
        breakpoints: [0, 1],
        handle:false,
        componentProps: {
          shop:this.shop,
          shopOutlets:this.shopOutlets
        }
      });
      await modal.present();
    } catch (error) {
      console.error(error)
    }
  }



  
}
